import { api } from './client';

/**
 * EL HISTORIAL COMPLETO DEL COPILOTO. Prefijo: /api/copiloto/historial.
 *
 * Solo lectura. Lo ve el OWNER o quien tenga el teléfono de un dueño activo del
 * directorio del asistente; a cualquier otro la API le responde 403. Cada
 * conversación que se abre (y cada "Cargar más") queda en el registro de
 * acciones.
 */

export interface PersonaDelHistorial {
  /** Lo que viaja en el filtro. */
  clave: string;
  nombre: string;
  telefono: string | null;
}

export interface HiloDelHistorial {
  id: string;
  titulo: string;
  persona: PersonaDelHistorial;
  origenes: string[];
  cantidad: number;
  primera: string;
  ultima: string;
  vistaPrevia: string;
}

export interface MensajeDelHistorial {
  id: string;
  rol: string;
  contenido: string;
  origen: string | null;
  /** "respuesta" | "aviso-sistema" | "error". */
  tipo: string;
  autor: { userId: string | null; telefono: string | null; nombre: string | null };
  createdAt: string;
}

/** ¿Mostrar la entrada del menú y abrir la pantalla? */
export const traerPermiso = () => api.get<{ puedeVer: boolean }>('/api/copiloto/historial/permiso');

/** Las personas que hablaron con el asistente, para el filtro. */
export const listarPersonas = () =>
  api.get<{ personas: PersonaDelHistorial[] }>('/api/copiloto/historial/personas');

/** Una página de hilos. `query` sale de `consultaDeHistorial`. */
export const listarHilos = (query: Record<string, string>) =>
  api.get<{ hilos: HiloDelHistorial[]; siguiente: string | null }>(
    '/api/copiloto/historial/hilos',
    { query },
  );

/** Una página de mensajes de un hilo, en orden. */
export const traerHilo = (id: string, cursor?: string | null) =>
  api.get<{
    hilo: { id: string; titulo: string; persona: PersonaDelHistorial };
    mensajes: MensajeDelHistorial[];
    siguiente: string | null;
  }>(`/api/copiloto/historial/hilos/${encodeURIComponent(id)}`, {
    query: cursor ? { cursor } : undefined,
  });
